import React, { useEffect, useState } from "react";
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import { base_url } from "../../utilities";
import axios from "axios";
import FormLoader from "../Reusable_Components/FromLoader";
import { useNavigate } from "react-router-dom";

export default function OrganizationPricing() {
    const navigate = useNavigate();




    const [pricingPlans, setPricingPlans] = useState([]);
    const [features, setFeatures] = useState([]);

    const [loading, setLoading] = useState(false);
    const communityPlan = pricingPlans.find(plan => plan.plan_name === "Community Plan");
    const enterprisePlan = pricingPlans.find(plan => plan.plan_name === "Enterprise Plan");

    const fetchPricingPlans = () => {
        setLoading(true);
        axios.get(base_url + "subscription/plans")
            .then((response) => {
                setLoading(false);
                setPricingPlans(response.data.data);
                setFeatures(response.data.data.features);
            })
            .catch((error) => {
                setLoading(false);
                setPricingPlans([]);
                setFeatures([]);
            });
    }

    useEffect(() => {
        fetchPricingPlans();
    }, []);

    const [isAnnual, setIsAnnual] = useState(false);

    const handleToggle = () => {
        setIsAnnual(!isAnnual);
    };

    

    return (
        <>
            {/* <NavBarTop />
            <LeftNavBar /> */}
            <div className="organization-pricing-container d-flex flex-column"
                // style={{ overflow: 'auto' }}'
                id='pricing'
            >
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex flex-column" style={{ marginBottom: "20px" }}>
                        <h3 className="invoice-heading mb-0" style={{ color: "#2d3748", fontWeight: 700 }}>Simple, transparent pricing</h3>
                    </div>
                    <div className="organization-pricing-details">
                        <p>Choose the plan that's right for your business and scale as you grow.</p>
                    </div>
                </div>

                <div className="d-flex justify-content-center align-items-center gap-2">
                    <div>
                        <span className={!isAnnual ? 'organization-pricing-active' : "organization-pricing-inactive"}>Monthly</span>
                    </div>
                    <div className="form-check form-switch">
                        <input
                            type="checkbox"
                            id="planSwitch"
                            className="form-check-input organization-pricing-toggle"
                            checked={isAnnual}
                            onChange={handleToggle}
                            style={{ cursor: 'pointer', height: '20px', width: '40px' }}
                        />
                    </div>
                    <div className="d-flex gap-1">
                        <span className={isAnnual ? 'organization-pricing-active' : "organization-pricing-inactive"}>Annual</span>
                        <span className="organization-pricing-save">Save {communityPlan?.discount_yearly}%</span>
                    </div>
                </div>

                <div className="d-flex justify-content-center container mt-4">
                    <div className="row justify-content-center">

                        <div className="col-12 col-md-6 mb-4">
                            <div className="d-flex flex-column justify-content-between organization-pricing-community-container h-100 p-4">
                                <div className="d-flex flex-column justify-content-between h-100">

                                    <div style={{ minHeight: '150px' }}>
                                        <h3 className="invoice-heading">{communityPlan?.plan_name}</h3>
                                        <p className="text-muted small mb-2">
                                            {communityPlan?.description}
                                        </p>
                                        <div className="d-flex flex-wrap align-items-baseline gap-1">
                                            <h3 className="invoice-heading m-0">{!isAnnual ? communityPlan?.discounted_price_montly : communityPlan?.discounted_price_yearly}</h3>
                                            <span className="m-0">INR / {isAnnual ? "year" : "month"}</span>
                                        </div>

                                    </div>

                                    <div className="d-flex flex-column gap-2 flex-grow-1">
                                        {communityPlan?.features.map((feature, index) => (
                                            <div key={index}>
                                                <span style={{ marginRight: "10px", fontWeight: "bold" }}>✓</span>
                                                <span>{feature}</span>
                                            </div>
                                        ))}
                                    </div>


                                    <div className="d-flex mt-4">
                                        <button className="organization-pricing-community-button" onClick={()=>{
                                            navigate("/community-register")
                                        }}>Register</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-md-6 mb-4">
                            <div className="d-flex flex-column justify-content-between organization-pricing-enterprise-container h-100 p-4">
                                <div className="d-flex flex-column justify-content-between h-100">

                                    <div style={{ minHeight: '150px' }}>
                                        <h3 className="invoice-heading text-white">{enterprisePlan?.plan_name}</h3>
                                        <p className="text-light small mb-2">
                                            {enterprisePlan?.description}
                                        </p>
                                        <div className="d-flex align-items-center mb-2">
                                            <span>
                                                <span style={{ textDecoration: "underline", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}>Contact Sales</span> for pricing estimates
                                            </span>
                                        </div>
                                    </div>


                                    <div className="d-flex flex-column gap-2 flex-grow-1">
                                        {enterprisePlan?.features.map((feature, index) => (
                                            <div key={index}>
                                                <span style={{ marginRight: "10px", fontWeight: "bold" }}>✓</span>
                                                <span>{feature}</span>
                                            </div>
                                        ))}
                                    </div>


                                    <div className="d-flex mt-4">
                                        <button
                                            className="organization-pricing-enterprise-button"
                                            onClick={() => {
                                                const el = document.getElementById('contactus');
                                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            Contact Sales
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <FormLoader />}
        </>
    );
}
